import useMediaQuery from '@mui/material/useMediaQuery';
import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import ButtonPrimary from '../../components/shared/Button/PrimaryButton';
import ButtonSecondary from '../../components/shared/Button/SecondaryButton';
import UiBox from '../../components/shared/Box';

const RegWorkflowButtons = (props: any): JSX.Element => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down(510));
  return (
    <Box
      sx={{
        display: 'flex',
        gap: '24px',
        flexWrap: 'wrap',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
      }}
      id="reg-workflow-buttons"
      className="ui-reg-workflow-buttons"
    >
      {props?.buttonItems?.map((buttonItem: any, buttonItemIndex: number) => {
        const isPrimary = buttonItem?.fields?.buttonVariant?.value === 'contained';
        return (
          <UiBox
            styles={{
              padding: '5px',
              width: isMobile ? '100%' : '212px',
              order:
                (buttonItem.fields?.link?.value?.text).toLowerCase() === 'back' && isMobile ? 1 : 0,
            }}
            key={buttonItemIndex}
          >
            {isPrimary && (
              <ButtonPrimary
                id={buttonItem.fields?.link.value.text}
                fullWidth
                disabled={buttonItemIndex === 1 ? !props?.enableNext : false}
                onClick={(event: any) =>
                  props.handleClick(
                    event,
                    buttonItem.fields?.link.value.href,
                    buttonItemIndex === 0 ? 'back' : 'next'
                  )
                }
              >
                {buttonItem.fields?.link.value.text}
              </ButtonPrimary>
            )}
            {!isPrimary && (
              <ButtonSecondary
                id={buttonItem.fields?.link.value.text}
                fullWidth
                disabled={buttonItemIndex === 1 ? !props?.enableNext : false}
                onClick={(event: any) =>
                  props.handleClick(
                    event,
                    buttonItem.fields?.link.value.href,
                    buttonItemIndex === 0 ? 'back' : 'next'
                  )
                }
              >
                {buttonItem.fields?.link.value.text}
              </ButtonSecondary>
            )}
          </UiBox>
        );
      })}
    </Box>
  );
};

export default RegWorkflowButtons;
